<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" class="mt-3">
                <form-wizard
                        title="Nuova Richiesta"
                        nextButtonText="Procedi"
                        backButtonText="Indietro"
                        finishButtonText="Invia Richiesta"
                        @on-complete="saveRequest"
                        subtitle="">
                    <tab-content
                            icon="fi flaticon-info"
                            title="Informazioni">
                        <society-match-wizards-step-one></society-match-wizards-step-one>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-football"
                            :beforeChange="validateStepTwo"
                            title="Partite">
                        <society-match-wizards-step-two
                                ref="SocietyMatchWizardStepTwo"
                                @onSelectMatch="(match) => matchRequest.match = match"
                                @onSectorsStatus="(sectors) => sectorsStatus = sectors"
                                :matches="availableMatches">

                        </society-match-wizards-step-two>
                    </tab-content>
                    <tab-content
                            :beforeChange="validateStepFour"
                            icon="fi flaticon-group"
                            title="Biglietti">
                        <society-match-wizards-step-four
                                ref="SocietyMatchWizardStepFour"
                                :sectorStatus = sectorsStatus
                                :match="matchRequest.match"
                                :contacts="contacts">
                        </society-match-wizards-step-four>
                    </tab-content>
                    <tab-content v-if="enableCC"
                                 icon="fi flaticon-euro"
                                 :beforeChange="validateStepThree"
                                 title=" Metodo di Pagamento">
                        <society-match-wizards-step-three
                            ref="SocietyMatchWizardStepThree"
                            @onChangePayment="(payment) => matchRequest.payment_method = payment"
                            :paymentMethod="matchRequest.payment_method" :matchRequest="matchRequest" :user="currentUser">
                        </society-match-wizards-step-three>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-tick"
                            title="Prenota">
                        <society-match-wizards-step-five :matchRequest="matchRequest">
                        </society-match-wizards-step-five>
                    </tab-content>
                </form-wizard>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    import {mapActions, mapGetters} from 'vuex';
    import MatchRequest from "@/models/MatchRequest";
    import SocietyMatchWizardsStepOne from "../components/society-matches-wizards/SocietyMatchWizardsStepOne";
    import SocietyMatchWizardsStepTwo from "../components/society-matches-wizards/SocietyMatchWizardsStepTwo";
    import SocietyMatchWizardsStepThree from "../components/society-matches-wizards/SocietyMatchWizardsStepThree";
    import SocietyMatchWizardsStepFour from "../components/society-matches-wizards/SocietyMatchWizardsStepFour";
    import SocietyMatchWizardsStepFive from "../components/society-matches-wizards/SocietyMatchWizardsStepFive";

    export default {
        name: "SocietyDashView",
        components: {
            SocietyMatchWizardsStepFive,
            SocietyMatchWizardsStepFour,
            SocietyMatchWizardsStepThree, SocietyMatchWizardsStepTwo, SocietyMatchWizardsStepOne
        },
        data() {
            return {
                headerButtons: [],
                availableMatches: [],
                matchRequest: Object.assign({}, MatchRequest),
                contacts: [],
                sectorsStatus : [],
                enableCC: process.env.VUE_APP_ENABLE_CC === 'true'
            }
        },
        computed: {
            ...mapGetters([
                'currentUser',
            ]),
        },

        mounted() {
            this.societyDashAvailableMacthes()
                .then((data) => {
                    this.availableMatches = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento dei match disponibili', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });

            this.societyContactGet()
                .then((data) => {
                    this.contacts = data;
                }).catch(() => {
                this.$bvToast.toast('Problemi nel caricamento dei contatti', {
                    title: 'Alert',
                    variant: 'warning'
                });
            });


        },
        methods: {

            ...mapActions({
                societyDashAvailableMacthes: 'societyDashAvailableMatches',
                societyContactGet: 'societyContactGet',
                societyMatchesStoreRequest: 'societyMatchesStoreRequest',
            }),

            validateStepTwo: function () {
                return this.$refs.SocietyMatchWizardStepTwo.validate();
            },

            validateStepThree: function () {
                if(!this.enableCC) {
                    return true;
                }
                return this.$refs.SocietyMatchWizardStepThree.validate();
            },

            validateStepFour: function () {
                this.matchRequest.details = this.$refs.SocietyMatchWizardStepFour.getSelectedContacts();
                return this.$refs.SocietyMatchWizardStepFour.validate();
            },

            saveRequest: function () {
                this.societyMatchesStoreRequest(this.matchRequest)
                    .then(() => {
                        this.$bvToast.toast('Richiesta insterita correttamente', {
                            title: 'Success',
                            variant: 'success'
                        });
                        this.$router.push({name : 'society.matches'});
                    })
                    .catch(() => {
                        this.$bvToast.toast('Inserimento richiesta non riuscito', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    })
            }

        }
    }
</script>

<style scoped>

</style>
